import { state } from '../store';
import { saveDifficulty } from '../api/client';

(window as any).__setDifficulty = (range: string | null) => {
  state.difficultyRange = range;
  saveDifficulty(range);
  if (typeof (window as any).renderApp === 'function') (window as any).renderApp();
  try { (window as any).Telegram?.WebApp?.HapticFeedback?.impactOccurred?.('light'); } catch(e) {}
};
